import {
  AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, QueryList, SimpleChanges,
  ViewChild, ViewChildren
} from '@angular/core';
import {OtherDocument, TreatyNavigation} from "../../models/treaty.models";
import {TreatyApiService} from "../../services/treaty.service";
import {ITreatyState} from "../../store/reducers/treaty.reducer";
import {Store} from "@ngrx/store";
import {getOtherDocument} from "../../store/selectors/treaty.selector";
import {GetOtherDocumentInfoAction} from "../../store/actions/treaty.actions";
import {ProjectService} from "../../../projects/services/project-service";
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';

@Component({
    standalone: false,
    selector: 'particle-treaty-document-sidebar',
  templateUrl: './treaty-document-sidebar.component.html',
  styleUrls: ['./treaty-document-sidebar.component.scss']
})
export class TreatyDocumentSidebarComponent implements OnInit, OnDestroy{
  isTreatyExpanded: boolean;
  isSocialSecurityExpanded: boolean;
  isOtherTreatyExpanded: boolean;
  isReadyTreatyDocument = false;
  isReadySocialSecurityDocument = false;
  isReadyOtherTreatyDocument = false;

  @Input() isShowOtherDocumentOnly = false;
  @Input() info: any;
  @Output() documentIdChanged = new EventEmitter<string>();
  @Input() refresh;
  @Input() projectId;
  currentDocumentId: string;
  otherDocuments: OtherDocument[];
  treatyItems: any[];
  socialSecurityItems: any[];
  ngUnsubscribe = new Subject<void>();
  constructor(private treatyService: TreatyApiService, private treatyStore: Store<ITreatyState>, private projectService: ProjectService) {
  }

  ngOnInit() {
    this.refresh.pipe(takeUntil(this.ngUnsubscribe)).subscribe(documentId => {
      console.log('Received refresh:::', documentId);
      this.currentDocumentId = documentId;
      this.onDocumentChange({documentId: documentId});
    });
    this.treatyStore.select(getOtherDocument).subscribe((data: OtherDocument[]) => {
      if (data) {
        this.otherDocuments = data.map(group => {
          return {...group, isExpanded: false};
        });
        if (this.currentDocumentId) {
          this.onDocumentChange({documentId: this.currentDocumentId});
        }
      } else {
        this.treatyStore.dispatch(new GetOtherDocumentInfoAction());
      }
    });
    if (this.info) {
      this.treatyService.getTreatyDocumentInfoAboutCountryPair(this.info.id, this.projectId).subscribe(data => {
        this.treatyItems = [];
        this.socialSecurityItems = [];
        data.forEach(d => {
          const item = <any>{...d, isActive: false};
          if (d.documentType === 'Tax Treaty Documents') {
            this.treatyItems.push(item);
          } else {
            this.socialSecurityItems.push(item);
          }
        });
        if(this.currentDocumentId) {
          this.onDocumentChange({documentId: this.currentDocumentId});
        }
      });
    }
  }

  clicked(item: any) {
    this.documentIdChanged.emit(item.documentId);
  }
  onDocumentChange(item: any) {
    this.isOtherTreatyExpanded = false;
    this.isTreatyExpanded = false;
    this.isSocialSecurityExpanded = false;
    if (!item?.documentId) {
      return;
    }
    if (this.otherDocuments) {
      this.otherDocuments.forEach(group => {
        let isActiveFind = false;
        group.navigation.forEach((navigation) => {
          navigation.isActive = navigation.documentId === item.documentId;
          if (navigation.isActive) {
            isActiveFind = true;
            this.isOtherTreatyExpanded = true;
          }
        });
        group.isExpanded = isActiveFind;
        if (group.isExpanded) {
          this.isOtherTreatyExpanded = true;
        }
      });
      this.isReadyOtherTreatyDocument = true;
    }
    if (this.treatyItems) {
      this.treatyItems.forEach(d => {
        d.isActive = d.documentId === item.documentId;
        if (d.isActive) {
          this.isTreatyExpanded = true;
        }
      });
      this.isReadyTreatyDocument = true;
    }
    if (this.socialSecurityItems) {
      this.socialSecurityItems.forEach(d => {
        d.isActive = d.documentId === item.documentId;
        if (d.isActive) {
          this.isSocialSecurityExpanded = true;
        }
      });
      this.isReadySocialSecurityDocument = true;
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
